import { render, staticRenderFns } from "./stepUi.vue?vue&type=template&id=b6a94c0c&scoped=true&"
import script from "./stepUi.vue?vue&type=script&lang=js&"
export * from "./stepUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a94c0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6a94c0c')) {
      api.createRecord('b6a94c0c', component.options)
    } else {
      api.reload('b6a94c0c', component.options)
    }
    module.hot.accept("./stepUi.vue?vue&type=template&id=b6a94c0c&scoped=true&", function () {
      api.rerender('b6a94c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/temporaryTemplate/goodsInbound/stepUi.vue"
export default component.exports